import React from "react"
import YouTube from "react-youtube"
import styled from "styled-components"
import media from "../utils/media"
import vars from "../utils/variables"
import * as PropTypes from "prop-types"

import iconPlayBtn from "./../images/icon_play.svg"

const propTypes = {
  youTubeId: PropTypes.string.isRequired,
  youTubePoster: PropTypes.object.isRequired,
}

const VideoWrapper = styled.div`
  display: block;
  flex: 1 1 100%;
  margin: 0 0 1.2rem 0;
  ${media.chTablet`
    flex: ${props => (props.hub ? "0 1 100%" : "0 1 45%")};
    margin: ${props => (props.hub ? "0 0 1.2rem 0" : "0 1.5rem 0 0")};
  `};
  ${media.tablet`
    flex: ${props => (props.hub ? "0 1 64%" : "0 1 45%")};
    margin: ${props => (props.hub ? "0 2rem 0 0" : "0 1.5rem 0 0")};
  `};
`

const VideoContainer = styled.div`
  position: relative;
  height: 0;
  overflow: hidden;
  padding: 0 0 56.2% 0;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
    z-index: 1;
  }
`

const Poster = styled.div`
  position: absolute;
  z-index: 2;
  cursor: pointer;
  transition: all .3s linear;
  opacity: ${props => (props.playing ? "0" : "1")};
  visibility: ${props => (props.playing ? "hidden" : "visible")};
  &:before {
    content: '';
    height: 60px;
    width: 60px;
    position: absolute;
    top: calc(50% - 30px);
    left: calc(50% - 30px);
    z-index: 3;
    opacity: 0.9;
    transition: all ${vars.transitionFast} linear;
    background-image: url(${iconPlayBtn});
    background-size: contain;
    ${media.phone`
      top: calc(50% - 50px);
      left: calc(50% - 50px);
      height: 100px;
      width: 100px;
    `}
  }
  &:hover {
    &:before {
      opacity: 1; 
    }
  }
`

const Image = styled.img`
  object-fit: cover;
`

const youTubeOptions = {
  playerVars: {
    autoplay: 0,
    autohide: 1,
    controls: 1,
    disablekb: 1,
    fs: 0,
    loop: 1,
    modestbranding: 1,
    playsinline: 1,
    widget_referrer: 0,
    mute: 0,
  }
}

class Video extends React.Component {
  constructor(props) {
    super(props)
    this.state = { playing: false }
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState({ playing: true })
    this.refs.player.internalPlayer.playVideo()
  }

  render() {
    return (
      <VideoWrapper hub={this.props.hub}>
        <VideoContainer>
          <Poster
            onClick={() => this.handleClick()}
            playing={this.state.playing}
          >
            <Image
              alt={this.props.youTubePoster.title}
              src={this.props.youTubePoster.responsiveResolution.src}
              srcSet={this.props.youTubePoster.responsiveResolution.srcSet} />
          </Poster>
          <YouTube ref="player" className="iframe" videoId={this.props.youTubeId} opts={youTubeOptions} />
        </VideoContainer>
      </VideoWrapper>
    )
  }
}

export default Video



// WEBPACK FOOTER //
// ./src/components/video.js